module.exports = __webpack_public_path__ + "img/hand-washing-is-the-first-defense.cde63238.jpg";